import React from 'react';
import { reduxForm } from 'redux-form';

import FlatButton from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { AccentColor } from 'helpers/AccentColorHelper';
import AddDocumentOfProofs from 'components/landlord_app/applications/ManualApplicantDrawer/AddDocumentOfProofs';
import { getTranslatedString } from 'helpers/i18n';
import withMobileDialog from '@material-ui/core/withMobileDialog';

let AddDocumentDialog = ({
  fullScreen,
  addDocumentDialogOpen,
  toggleAddDocumentDialog,
  handleSubmit,
}) => {
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={addDocumentDialogOpen}
        aria-labelledby="add-new-applicant"
        classes={{ paper: 'form-dialog' }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            height: '100%',
          }}
        >
          <DialogTitle id="add-new-applicant" style={{ margin: '0 100px' }}>
            <div>
              <h3 style={{ textAlign: 'center', margin: 0 }}>
                {getTranslatedString('landlordPortal.addDocumentDialog.addDocument')}
              </h3>
            </div>
          </DialogTitle>
          <DialogContent>
            <AddDocumentOfProofs dialog />
          </DialogContent>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 4px' }}>
            <FlatButton onClick={() => toggleAddDocumentDialog()} style={{ color: AccentColor() }}>
              {getTranslatedString('landlordPortal.addDocumentDialog.close')}
            </FlatButton>
            <FlatButton
              type="submit"
              variant="contained"
              style={{
                color: 'white',
                backgroundColor: AccentColor(),
              }}
            >
              {getTranslatedString('landlordPortal.addDocumentDialog.saveDocument')}
            </FlatButton>
          </div>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

AddDocumentDialog = reduxForm({
  form: 'add_document',
})(AddDocumentDialog);

export default withMobileDialog()(AddDocumentDialog);
